import React from 'react'

import Modal, { ModalProps } from 'components/_new/modal/Modal/Modal'
import Buttons, { ButtonsProps } from './Buttons/Buttons'


export type DialogModalProps = ModalProps & ButtonsProps

const DialogModal: React.FunctionComponent<DialogModalProps> = ({ children, title, text, leftButton, rightButton, dataTestId, onClose }) => (
  <Modal
    title={title}
    text={text}
    dataTestId={dataTestId}
    footerNode={<Buttons leftButton={leftButton} rightButton={rightButton} />}
    onClose={onClose}
  >
    {children}
  </Modal>
)


export default DialogModal
